export default {
  "wt-radio-button": "_wt-radio-button_v01624_1",
  "wt-radio-button__error-message": "_wt-radio-button__error-message_v01624_10",
  "wt-radio-button__input": "_wt-radio-button__input_v01624_16",
  "wt-radio-button__icon": "_wt-radio-button__icon_v01624_31",
  "wt-radio-button_theme_light": "_wt-radio-button_theme_light_v01624_48",
  "wt-radio-button_theme_dark": "_wt-radio-button_theme_dark_v01624_54",
  "wt-radio-button_size_m": "_wt-radio-button_size_m_v01624_60",
  "wt-radio-button_size_s": "_wt-radio-button_size_s_v01624_61",
  "wt-radio-button_size_xs": "_wt-radio-button_size_xs_v01624_67",
  "wt-radio-button__icon_error": "_wt-radio-button__icon_error_v01624_73",
  "wt-radio-button__label": "_wt-radio-button__label_v01624_80"
};